module.exports = __webpack_public_path__ + "static/img/图标背景.391760e7.png";